export interface TaxDocumentConfig {
  name: string;
  required: boolean;
  cardTitle: string;
  cardDescriptionInitialText?: string;
  cardDescriptionLinks?: TaxDocumentCardLink[];
}

export interface TaxDocumentCardLink {
  linkText: string;
  afterLinkText: string;
  linkUrl?: string;
  s3ReferenceKey?: string;
  forZoneCodes?: string[];
  excludeZoneCodes?: string[];
}

export const TaxInfoConfig: Record<string, TaxDocumentConfig[]> = {
  AU: [
    {
      name: "auSuperannuationStandardChoiceForm",
      required: true,
      // t("auSuperannuationStandardChoiceForm.cardTitle")
      cardTitle: "auSuperannuationStandardChoiceForm.cardTitle",
      // t("auSuperannuationStandardChoiceForm.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "auSuperannuationStandardChoiceForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("auSuperannuationStandardChoiceForm.linkText")
          linkText: "auSuperannuationStandardChoiceForm.linkText",
          // t("auSuperannuationStandardChoiceForm.afterLinkText")
          afterLinkText: "auSuperannuationStandardChoiceForm.afterLinkText",
          s3ReferenceKey: "aus_superannuation_choice",
        },
      ],
    },
    {
      name: "auTfn",
      required: true,
      // t("auTfn.cardTitle")
      cardTitle: "auTfn.cardTitle",
      // t("auTfn.cardDescriptionInitialText")
      cardDescriptionInitialText: "auTfn.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("auTfn.linkText")
          linkText: "auTfn.linkText",
          // t("auTfn.afterLinkText")
          afterLinkText: "auTfn.afterLinkText",
          s3ReferenceKey: "aus_tfn_declaration",
        },
      ],
    },
  ],
  BR: [
    {
      name: "brCtps",
      required: true,
      // t("brCtps.cardTitle")
      cardTitle: "brCtps.cardTitle",
    },
  ],
  CA: [
    {
      name: "caTd1FederalForm",
      required: true,
      // t("caTd1FederalForm.cardTitle")
      cardTitle: "caTd1FederalForm.cardTitle",
      // t("caTd1FederalForm.cardDescriptionInitialText")
      cardDescriptionInitialText: "caTd1FederalForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("caTd1FederalForm.linkText")
          linkText: "caTd1FederalForm.linkText",
          // t("caTd1FederalForm.afterLinkText")
          afterLinkText: "caTd1FederalForm.afterLinkText",
          linkUrl:
            "https://www.canada.ca/en/revenue-agency/services/forms-publications/td1-personal-tax-credits-returns/td1-forms-pay-received-on-january-1-later/td1.html",
        },
      ],
    },
    {
      name: "caTd1ProvincialForm",
      required: true,
      // t("caTd1ProvincialForm.cardTitle")
      cardTitle: "caTd1ProvincialForm.cardTitle",
      // t("caTd1ProvincialForm.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "caTd1ProvincialForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("caTd1QCProvincialForm.linkText")
          linkText: "caTd1QCProvincialForm.linkText",
          // t("caTd1QCProvincialForm.afterLinkText")
          afterLinkText: "caTd1QCProvincialForm.afterLinkText",
          linkUrl:
            "https://www.revenuquebec.ca/en/online-services/forms-and-publications/current-details/tp-1015-3-v/",
          forZoneCodes: ["QC"],
        },
        {
          // t("caTd1BCProvincialForm.linkText")
          linkText: "caTd1BCProvincialForm.linkText",
          // t("caTd1BCProvincialForm.afterLinkText")
          afterLinkText: "caTd1BCProvincialForm.afterLinkText",
          linkUrl:
            "https://www.canada.ca/en/revenue-agency/services/forms-publications/td1-personal-tax-credits-returns/td1-forms-pay-received-on-january-1-later.html",
          excludeZoneCodes: ["QC"],
        },
        {
          // t("caHelpCenter.linkText")
          linkText: "caHelpCenter.linkText",
          // t("caHelpCenter.afterLinkText")
          afterLinkText: "caHelpCenter.afterLinkText",
          linkUrl:
            "https://help.justworks.com/hc/en-us/articles/44072455921435-Working-in-Canada-with-Justworks-TD1-Forms-Provincial-Tax-Withholding",
          excludeZoneCodes: ["QC"],
        },
      ],
    },
  ],
  CL: [
    {
      name: "clAfp",
      required: true,
      // t("clAfp.cardTitle")
      cardTitle: "clAfp.cardTitle",
    },
    {
      name: "clAhs",
      required: true,
      // t("clAhs.cardTitle")
      cardTitle: "clAhs.cardTitle",
    },
  ],
  ES: [
    {
      name: "esModelo145",
      required: true,
      // t("esModelo145.cardTitle")
      cardTitle: "esModelo145.cardTitle",
    },
  ],
  GB: [
    {
      name: "gbP45Form",
      required: true,
      // t("gbP45Form.cardTitle")
      cardTitle: "gbP45Form.cardTitle",
      // t("gbP45Form.cardDescriptionInitialText")
      cardDescriptionInitialText: "gbP45Form.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("gbP45Form.linkText")
          linkText: "gbP45Form.linkText",
          // t("gbP45Form.afterLinkText")
          afterLinkText: "gbP45Form.afterLinkText",
          linkUrl:
            "https://assets.publishing.service.gov.uk/media/6331a05f8fa8f51d29278ebc/Starter_checklist.pdf",
        },
      ],
    },
  ],
  IN: [
    {
      name: "inFormB12",
      required: true,
      // t("inFormB12.cardTitle")
      cardTitle: "inFormB12.cardTitle",
      cardDescriptionInitialText: " ",
      cardDescriptionLinks: [
        {
          // t("inFormB12.linkText")
          linkText: "inFormB12.linkText",
          // t("inFormB12.afterLinkText")
          afterLinkText: "inFormB12.afterLinkText",
          s3ReferenceKey: "in_12b",
        },
      ],
    },
  ],
  IT: [
    {
      name: "itTesseraSanitaria",
      required: true,
      // t("itTesseraSanitaria.cardTitle")
      cardTitle: "itTesseraSanitaria.cardTitle",
    },
    {
      name: "itTfr",
      required: true,
      // t("itTfr.cardTitle")
      cardTitle: "itTfr.cardTitle",
      // t("itTfr.cardDescriptionInitialText")
      cardDescriptionInitialText: "itTfr.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("itTfr.linkText")
          linkText: "itTfr.linkText",
          afterLinkText: ".",
          s3ReferenceKey: "it_tfr",
        },
      ],
    },
    {
      name: "itRimpatriati",
      required: false,
      // t("itRimpatriati.cardTitle")
      cardTitle: "itRimpatriati.cardTitle",
      // t("itRimpatriati.cardDescriptionInitialText")
      cardDescriptionInitialText: "itRimpatriati.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("itRimpatriati.linkText")
          linkText: "itRimpatriati.linkText",
          afterLinkText: ".",
          s3ReferenceKey: "it_rimpatriati",
        },
      ],
    },
    {
      name: "itRichiestaDetrazioniFiscali",
      required: true,
      // t("itRichiestaDetrazioniFiscali.cardTitle")
      cardTitle: "itRichiestaDetrazioniFiscali.cardTitle",
      // t("itRichiestaDetrazioniFiscali.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "itRichiestaDetrazioniFiscali.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("itRichiestaDetrazioniFiscali.linkText")
          linkText: "itRichiestaDetrazioniFiscali.linkText",
          afterLinkText: ".",
          s3ReferenceKey: "it_richiesta_detrazioni_fiscali",
        },
      ],
    },
  ],
  MX: [
    {
      name: "mxCsf",
      required: true,
      // t("mxCsf.cardTitle")
      cardTitle: "mxCsf.cardTitle",
    },
    {
      name: "mxProofOfAddress",
      required: true,
      // t("mxProofOfAddress.cardTitle")
      cardTitle: "mxProofOfAddress.cardTitle",
    },
  ],
  MY: [
    {
      name: "myTp3Form",
      required: true,
      // t("myTp3Form.cardTitle")
      cardTitle: "myTp3Form.cardTitle",
      // t("myTp3Form.cardDescriptionInitialText")
      cardDescriptionInitialText: "myTp3Form.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          linkText: "myTp3Form.linkText",
          afterLinkText: "myTp3Form.afterLinkText",
          s3ReferenceKey: "my_tp3",
        },
      ],
    },
  ],
  CO: [
    {
      name: "coRegistroUnicoTributario",
      required: true,
      // t("coRegistroUnicoTributario.cardTitle")
      cardTitle: "coRegistroUnicoTributario.cardTitle",
    },
    {
      name: "coEps",
      required: true,
      // t("coEps.cardTitle")
      cardTitle: "coEps.cardTitle",
    },
    {
      name: "coSeveranceFund",
      required: true,
      // t("coSeveranceFund.cardTitle")
      cardTitle: "coSeveranceFund.cardTitle",
    },
    {
      name: "coPensionFund",
      required: true,
      // t("coPensionFund.cardTitle")
      cardTitle: "coPensionFund.cardTitle",
    },
    {
      name: "coBankAccountStatement",
      required: true,
      // t("coBankAccountStatement.cardTitle")
      cardTitle: "coBankAccountStatement.cardTitle",
    },
  ],
  NL: [
    {
      name: "nlPayrollTaxes",
      required: true,
      // t("nlPayrollTaxes.cardTitle")
      cardTitle: "nlPayrollTaxes.cardTitle",
      cardDescriptionInitialText: "Upload your completed ",
      cardDescriptionLinks: [
        {
          linkText: "statement of data for payroll taxes",
          afterLinkText:
            " to ensure the right amount of tax is taken from your pay according to Dutch regulations.",
          linkUrl:
            "https://download.belastingdienst.nl/belastingdienst/docs/stat-of-dat-payroll-taxes-lh0082z5foleng.pdf",
        },
      ],
    },
  ],
  NZ: [
    {
      name: "nzIr330TaxForm",
      required: true,
      // t("nzIr330TaxForm.cardTitle")
      cardTitle: "nzIr330TaxForm.cardTitle",
      // t("nzIr330TaxForm.cardDescriptionInitialText")
      cardDescriptionInitialText: "nzIr330TaxForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("nzIr330TaxForm.linkText")
          linkText: "nzIr330TaxForm.linkText",
          // t("nzIr330TaxForm.afterLinkText")
          afterLinkText: "nzIr330TaxForm.afterLinkText",
          s3ReferenceKey: "nz_ir330",
        },
      ],
    },
    {
      name: "nzKs2KiwisaverForm",
      required: false,
      // t("nzKs2KiwisaverForm.cardTitle")
      cardTitle: "nzKs2KiwisaverForm.cardTitle",
      // t("nzKs2KiwisaverForm.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "nzKs2KiwisaverForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("nzKs2KiwisaverForm.linkText")
          linkText: "nzKs2KiwisaverForm.linkText",
          // t("nzKs2KiwisaverForm.afterLinkText")
          afterLinkText: "nzKs2KiwisaverForm.afterLinkText",
          s3ReferenceKey: "nz_ks2_kiwisaver",
        },
      ],
    },
    {
      name: "nzKs10KiwisaverOptOutForm",
      required: false,
      // t("nzKs10KiwisaverOptOutForm.cardTitle")
      cardTitle: "nzKs10KiwisaverOptOutForm.cardTitle",
      // t("nzKs10KiwisaverOptOutForm.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "nzKs10KiwisaverOptOutForm.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("nzKs10KiwisaverOptOutForm.linkText")
          linkText: "nzKs10KiwisaverOptOutForm.linkText",
          // t("nzKs10KiwisaverOptOutForm.afterLinkText")
          afterLinkText: "nzKs10KiwisaverOptOutForm.afterLinkText",
          s3ReferenceKey: "nz_ks10_kiwisaver_opt_out",
        },
      ],
    },
  ],
  PE: [
    {
      name: "peRiskAssessment",
      required: true,
      // t("peRiskAssessment.cardTitle")
      cardTitle: "peRiskAssessment.cardTitle",
      // t("peRiskAssessment.cardDescriptionInitialText")
      cardDescriptionInitialText: "peRiskAssessment.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("peRiskAssessment.linkText")
          linkText: "peRiskAssessment.linkText",
          afterLinkText: ".",
          s3ReferenceKey: "pe_risk_assessment",
        },
      ],
    },
  ],
  PH: [
    {
      name: "phForm1902",
      required: true,
      // t("phForm1902.cardTitle")
      cardTitle: "phForm1902.cardTitle",
    },
  ],
  PT: [
    {
      name: "ptDeclaracao99",
      required: true,
      // t("ptDeclaracao99.cardTitle")
      cardTitle: "ptDeclaracao99.cardTitle",
      cardDescriptionInitialText: "Upload your completed ",
      cardDescriptionLinks: [
        {
          linkText: "Declaração 99",
          afterLinkText:
            " to ensure the right amount of tax is withheld from your pay according to Portuguese regulations.",
          linkUrl:
            "https://www.fd.ulisboa.pt/wp-content/uploads/2014/12/declaracao-99-IRS.pdf",
        },
      ],
    },
  ],
  SE: [
    {
      name: "seATax",
      required: true,
      // t("seATax.cardTitle")
      cardTitle: "seATax.cardTitle",
    },
  ],
  IL: [
    {
      name: "ilForm101",
      required: true,
      // t("ilForm101.cardTitle")
      cardTitle: "ilForm101.cardTitle",
      cardDescriptionInitialText: "Please download ",
      cardDescriptionLinks: [
        {
          linkText: "Form 101",
          afterLinkText: " complete it and upload it here.",
          linkUrl: "https://www.gov.il/he/service/itc101",
        },
      ],
    },
    {
      name: "ilTaxCoordinationDocument",
      required: false,
      // t("ilTaxCoordinationDocument.cardTitle")
      cardTitle: "ilTaxCoordinationDocument.cardTitle",
      cardDescriptionInitialText:
        "If you worked at a company in the past year, please fill out the tax coordination document and upload it here.",
    },
    {
      name: "ilDonPizurDohKubiot",
      required: false,
      // t("ilDonPizurDohKubiot.cardTitle")
      cardTitle: "ilDonPizurDohKubiot.cardTitle",
      cardDescriptionInitialText:
        "If you contribute to a pension plan, please upload your Doh Pizur or Doh Kubiot here.",
    },
  ],
  RO: [
    {
      name: "roDegreeCertificate",
      required: true,
      // t("roDegreeCertificate.cardTitle")
      cardTitle: "roDegreeCertificate.cardTitle",
    },
    {
      name: "roMedicalCertificate",
      required: false,
      // t("roMedicalCertificate.cardTitle")
      cardTitle: "roMedicalCertificate.cardTitle",
      // t("roMedicalCertificate.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "roMedicalCertificate.cardDescriptionInitialText",
    },
    {
      name: "roSixMonthIncomeCertificate",
      required: false,
      // t("roSixMonthIncomeCertificate.cardTitle")
      cardTitle: "roSixMonthIncomeCertificate.cardTitle",
      // t("roSixMonthIncomeCertificate.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "roSixMonthIncomeCertificate.cardDescriptionInitialText",
    },
  ],
  US: [
    {
      name: "prForm499r41",
      required: true,
      // t("prForm499r41.cardTitle")
      cardTitle: "prForm499r41.cardTitle",
      // t("prForm499r41.cardDescriptionInitialText")
      cardDescriptionInitialText: "prForm499r41.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("prForm499r41.linkText")
          linkText: "prForm499r41.linkText",
          // t("prForm499r41.afterLinkText")
          afterLinkText: "prForm499r41.afterLinkText",
          linkUrl:
            "https://hacienda.pr.gov/sites/default/files/documentos/499_r-4_1.pdf",
        },
        {
          // t("prForm499r42.linkText")
          linkText: "prForm499r42.linkText",
          // t("prForm499r42.afterLinkText")
          afterLinkText: "prForm499r42.afterLinkText",
          linkUrl:
            "https://hacienda.pr.gov/sites/default/files/documentos/499_r-4_2.pdf",
        },
      ],
    },
  ],
  UY: [
    {
      name: "uyForm3100",
      required: true,
      // t("uyForm3100.cardTitle")
      cardTitle: "uyForm3100.cardTitle",
      // t("uyForm3100.cardDescriptionInitialText")
      cardDescriptionInitialText: "uyForm3100.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("uyForm3100.linkText")
          linkText: "uyForm3100.linkText",
          // t("uyForm3100.afterLinkText")
          afterLinkText: "uyForm3100.afterLinkText",
          s3ReferenceKey: "uy_form_3100",
        },
        {
          // t("uyForm3100Instructions.linkText")
          linkText: "uyForm3100Instructions.linkText",
          afterLinkText: ".",
          s3ReferenceKey: "uy_form_3100_instructions",
        },
      ],
    },
    {
      name: "uyFonasaDeclaration",
      required: true,
      // t("uyFonasaDeclaration.cardTitle")
      cardTitle: "uyFonasaDeclaration.cardTitle",
      // t("uyFonasaDeclaration.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "uyFonasaDeclaration.cardDescriptionInitialText",
      cardDescriptionLinks: [
        {
          // t("uyFonasaDeclaration.linkText")
          linkText: "uyFonasaDeclaration.linkText",
          afterLinkText: ".",
          linkUrl:
            "https://www.bps.gub.uy/bps/file/1099/8/declaracion-del-trabajador-snis.pdf",
        },
      ],
    },
  ],
  ZA: [
    {
      name: "zaProofOfAddress",
      required: true,
      // t("zaProofOfAddress.cardTitle")
      cardTitle: "zaProofOfAddress.cardTitle",
      // t("zaProofOfAddress.cardDescriptionInitialText")
      cardDescriptionInitialText: "zaProofOfAddress.cardDescriptionInitialText",
    },
    {
      name: "zaProofOfSarsRegistration",
      required: false,
      // t("zaProofOfSarsRegistration.cardTitle")
      cardTitle: "zaProofOfSarsRegistration.cardTitle",
      // t("zaProofOfSarsRegistration.cardDescriptionInitialText")
      cardDescriptionInitialText:
        "zaProofOfSarsRegistration.cardDescriptionInitialText",
    },
  ],
  HR: [
    {
      name: "hrPkKartica",
      required: true,
      // t("hrPkKartica.cardTitle")
      cardTitle: "hrPkKartica.cardTitle",
    },
    {
      name: "hrBankStatement",
      required: true,
      // t("hrBankStatement.cardTitle")
      cardTitle: "hrBankStatement.cardTitle",
    },
  ],
};
